import styled from "styled-components";

export const RoomsContainer = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(23rem, 1fr));
  gap: 3rem;
`;
